import type { TranslationModule } from '../types';

export const mainContentTranslations: TranslationModule = {
  ro: {
    factualBackground: "Situație de fapt",
    arguments: "Argumente",
    individualization: "Individualizare",
    doctrine: "Doctrină",
    lessons: "Ce învățăm",
    aiSummary: "Rezumat AI",
    accessoryRequests: "Cereri accesorii",
    searchSuggestions: "Sugestii de căutare",
    aiSelectedHeader: "Spețe relevante — analiză AI",
    extendedSolrHeader: "Rezultate extinse din Motorul de Căutare Avansat",
    aiSelectedNext: "Spețele AI urmează mai jos ↓",
    reachedEnd: "Ați ajuns la sfârșitul listei.",
    limitReachedTitle: "Ai atins limita de {limit} afișări",
    limitReachedDesc: "Pentru a vizualiza toate rezultatele și a debloca accesul nelimitat la funcționalitățile profesionale, fă upgrade la un cont superior.",
    upgradeCTA: "Vezi Abonamentele",
    dataNotice: "Date preluate din portal.just.ro — Ministerul Justiției și instanțele de judecată din România. Reproducere autorizată conform termenilor portal.just.ro, cu mențiunea sursei.",
    caseResultsTitle: "Rezultate Dosar {numar}",
    dosarSearchLoading: "Căutare după număr dosar...",
    searchElse: "Caută altceva...",
    orderLabel: "Ordonare după:",
    selectCriterium: "Selectează un criteriu pentru a reordona rezultatele",
    gridTestNew: "Nou",
    gridTestTitle: "Teste Grilă din Spețe",
    gridTestDesc: "Generează automat teste grilă din întrebările de doctrină identificate în rezultatele căutării tale. Verifică-ți cunoștințele și pregătește-te eficient.",
    gridTestCTA: "Începe Testul",
    aiIdentifiedActs: "Acte Juridice Identificate de AI",
    selectActOption: "Selectați un act juridic relevant...",
    generateActBtn: "Generează Act Juridic",
    generatingBtn: "Se generează...",
    aiActsTip: "Selectați un tip de act și apăsați \"Generează\" pentru a crea un proiect personalizat bazat pe spețele de mai jos.",
    generatedActTitle: "Act Juridic Generat",
    timeoutError: "Timeout: generarea documentului a durat prea mult.",
    genError: "A apărut o eroare la generarea documentului.",
    aiAnalysisStarting: "Analizez contextul juridic cu AI pentru a găsi cea mai relevantă spetă... (poate dura câteva minute)",
    aiAnalysisQueued: "În coadă pentru analiză AI...",
    aiAnalysisProcessing: "AI analizează datele...",
    aiAnalysisFailed: "Filtrarea AI nu a putut fi aplicată.",
    aiNoResults: "AI-ul nu a găsit rezultate relevante.",
    pollError: "Eroare la procesarea răspunsului AI.",
    inputSomething: "Introduceți un text sau selectați un obiect pentru a căuta.",
    loadingMore: "Se încarcă mai multe rezultate...",
    foundResults: "Au fost găsite {count} rezultate.",
    foundResultsLimit: "Au fost găsite {count} rezultate. (Limitat la {limit} pentru {role}. Upgrade pentru mai multe.)",
    searchError: "Eroare la încărcarea rezultatelor: {message}",
    ecrisSearchStatus: "Căutare dosare în baza locală ECRIS...",
    ecrisSearchError: "Eroare la căutarea dosarelor în ECRIS: {message}",
    ecrisSearchCount: "Au fost găsite {count} dosare în baza locală ECRIS pentru «{query}».",
    ecrisSearchEmpty: "Nu am găsit dosare în baza locală ECRIS pentru «{query}».",
    ecrisSearchTimeout: "Căutarea în baza locală ECRIS a durat prea mult. Vă rugăm să reîncercați.",
    ecrisSearchUnavailable: "Baza de date ECRIS este temporar indisponibilă. Vă rugăm să reîncercați.",
    globalCompanySearchStatus: "Căutare date companie și litigii...",
    globalCompanySearchCount: "Au fost găsite {litigii} litigii și {solr} detalii firmă pentru \"{query}\".",
    globalCompanySearchEmpty: "Nu am găsit rezultate pentru societatea \"{query}\".",
    globalCompanySearchError: "Eroare la căutarea companiei: {message}",
    dosarSearchStatus: "Căutare după număr dosar...",
    dosarSearchCount: "Căutare după număr dosar \"{numar}\": {count} spețe similare găsite.",
    dosarSearchEmpty: "Nu au fost găsite spețe similare pentru dosarul \"{numar}\"",
    copied: "Copiat!",
    copyText: "Copiază Textul"
  },
  en: {
    factualBackground: "Factual Background",
    arguments: "Court Arguments",
    individualization: "Individualization",
    doctrine: "Legal Doctrine",
    lessons: "Lessons Learned",
    aiSummary: "AI Summary",
    accessoryRequests: "Accessory Requests",
    searchSuggestions: "Search Suggestions",
    aiSelectedHeader: "Relevant Case Law — AI Semantic Analysis",
    extendedSolrHeader: "Extended Search Results",
    aiSelectedNext: "AI selected case law follows below ↓",
    reachedEnd: "You have reached the end of the list.",
    limitReachedTitle: "You have reached the view limit of {limit}",
    limitReachedDesc: "To view all search results and unlock unlimited access to professional legal tech tools, please upgrade your subscription plan.",
    upgradeCTA: "View Pricing Plans",
    dataNotice: "Information fetched from portal.just.ro — Ministry of Justice and the Romanian courts of law. Reproduction authorized under portal.just.ro terms, with proper attribution of the source.",
    caseResultsTitle: "Results for Case File {numar}",
    dosarSearchLoading: "Searching by case file number...",
    searchElse: "Search for something else...",
    orderLabel: "Sort by:",
    selectCriterium: "Select a criterion to reorder results",
    gridTestNew: "New",
    gridTestTitle: "AI Quiz Generator from Case Law",
    gridTestDesc: "Automatically generate multiple-choice quiz questions from the legal doctrine and jurisprudence identified in your search results. Test your knowledge and prepare effectively.",
    gridTestCTA: "Start Quiz",
    aiIdentifiedActs: "Legal Documents Identified by AI",
    selectActOption: "Select a relevant legal document...",
    generateActBtn: "Generate Legal Document",
    generatingBtn: "Generating...",
    aiActsTip: "Select a document type and press \"Generate\" to draft a customized template project based on the case law below.",
    generatedActTitle: "Generated Legal Document",
    timeoutError: "Timeout: document generation has taken too long.",
    genError: "An error occurred during document generation.",
    aiAnalysisStarting: "Analyzing the legal context with AI to identify the most relevant precedent... (this may take a few minutes)",
    aiAnalysisQueued: "Queued for AI analysis...",
    aiAnalysisProcessing: "AI is analyzing the data...",
    aiAnalysisFailed: "Semantic AI filtering could not be applied.",
    aiNoResults: "The AI did not find any highly relevant precedents.",
    pollError: "Error processing the AI analysis response.",
    inputSomething: "Please enter text or select a legal object/matter to perform a search.",
    loadingMore: "Loading more results...",
    foundResults: "Found {count} results.",
    foundResultsLimit: "Found {count} results. (Limited to {limit} for {role} role. Upgrade for full access.)",
    searchError: "Error loading results: {message}",
    ecrisSearchStatus: "Searching for cases in local ECRIS database...",
    ecrisSearchError: "Error searching cases in ECRIS: {message}",
    ecrisSearchCount: "Found {count} cases in local ECRIS database for \"{query}\".",
    ecrisSearchEmpty: "No cases found in local ECRIS database for \"{query}\".",
    ecrisSearchTimeout: "The search in local ECRIS database timed out. Please try again.",
    ecrisSearchUnavailable: "The ECRIS database is temporarily unavailable. Please try again.",
    globalCompanySearchStatus: "Fetching company metrics and litigation history...",
    globalCompanySearchCount: "Found {litigii} litigation records and {solr} corporate records for \"{query}\".",
    globalCompanySearchEmpty: "No corporate or litigation records found for \"{query}\".",
    globalCompanySearchError: "Error fetching company data: {message}",
    dosarSearchStatus: "Searching by case number...",
    dosarSearchCount: "Search by case file number \"{numar}\": {count} similar case precedents identified.",
    dosarSearchEmpty: "No similar court case precedents found for file \"{numar}\"",
    copied: "Copied!",
    copyText: "Copy Text"
  },
  fr: {
    factualBackground: "Exposé des faits",
    arguments: "Arguments de la Cour",
    individualization: "Individualisation",
    doctrine: "Doctrine Juridique",
    lessons: "Enseignements Tirés",
    aiSummary: "Résumé de l'IA",
    accessoryRequests: "Demandes accessoires",
    searchSuggestions: "Suggestions de recherche",
    aiSelectedHeader: "Jurisprudence Pertinente — Analyse Sémantique IA",
    extendedSolrHeader: "Résultats de Recherche Étendus",
    aiSelectedNext: "La jurisprudence sélectionnée par l'IA suit ci-dessous ↓",
    reachedEnd: "Vous avez atteint la fin de la liste.",
    limitReachedTitle: "Vous avez atteint la limite de {limit} affichages",
    limitReachedDesc: "Pour visualiser tous les résultats et débloquer l'accès illimité à nos fonctionnalités professionnelles LegalTech, veuillez passer à un forfait supérieur.",
    upgradeCTA: "Voir les Tarifs",
    dataNotice: "Données extraites de portal.just.ro — Ministère de la Justice et cours de justice roumaines. Reproduction autorisée selon les termes de portal.just.ro, avec mention de la source.",
    caseResultsTitle: "Résultats pour le Dossier {numar}",
    dosarSearchLoading: "Recherche par numéro de dossier en cours...",
    searchElse: "Rechercher autre chose...",
    orderLabel: "Trier par :",
    selectCriterium: "Sélectionnez un critère pour réordonner les résultats",
    gridTestNew: "Nouveau",
    gridTestTitle: "Générateur de QCM IA à partir de Jurisprudence",
    gridTestDesc: "Génère automatiquement des QCM à partir des points de doctrine et de la jurisprudence identifiés dans vos résultats de recherche. Testez vos connaissances et préparez-vous efficacement.",
    gridTestCTA: "Démarrer le Test",
    aiIdentifiedActs: "Actes Juridiques Identifiés par l'IA",
    selectActOption: "Sélectionnez un acte juridique pertinent...",
    generateActBtn: "Générer l'Acte Juridique",
    generatingBtn: "Génération...",
    aiActsTip: "Sélectionnez un type d'acte et cliquez sur \"Générer\" pour rédiger un projet de modèle personnalisé basé sur la jurisprudence ci-dessous.",
    generatedActTitle: "Acte Juridique Généré",
    timeoutError: "Timeout : la génération du document a duré trop longtemps.",
    genError: "Une erreur est survenue lors de la génération du document.",
    aiAnalysisStarting: "Analyse du contexte juridique par l'IA en cours pour identifier le précédent le plus pertinent... (cela peut prendre quelques minutes)",
    aiAnalysisQueued: "En file d'attente pour l'analyse IA...",
    aiAnalysisProcessing: "L'IA analyse les données...",
    aiAnalysisFailed: "Le filtrage sémantique de l'IA n'a pas pu être appliqué.",
    aiNoResults: "L'IA n'a trouvé aucun précédent hautement pertinent.",
    pollError: "Erreur lors du traitement de la réponse d'analyse de l'IA.",
    inputSomething: "Veuillez saisir un texte ou sélectionner un objet juridique pour effectuer une recherche.",
    loadingMore: "Chargement de résultats supplémentaires...",
    foundResults: "Trouvé {count} résultats.",
    foundResultsLimit: "Trouvé {count} résultats. (Limité à {limit} pour le rôle {role}. Passez au forfait supérieur pour un accès complet.)",
    searchError: "Erreur lors du chargement des résultats : {message}",
    ecrisSearchStatus: "Recherche de dossiers dans la base locale ECRIS...",
    ecrisSearchError: "Erreur lors de la recherche de dossiers ECRIS : {message}",
    ecrisSearchCount: "Trouvé {count} dossiers dans la base locale ECRIS pour «{query}».",
    ecrisSearchEmpty: "Aucun dossier trouvé dans la base locale ECRIS pour «{query}».",
    ecrisSearchTimeout: "La recherche dans la base locale ECRIS a expiré. Veuillez réessayer.",
    ecrisSearchUnavailable: "La base de données ECRIS est temporairement indisponible. Veuillez réessayer.",
    globalCompanySearchStatus: "Récupération des métriques d'entreprise et de l'historique des litiges...",
    globalCompanySearchCount: "Trouvé {litigii} litiges et {solr} fiches d'entreprise pour \"{query}\".",
    globalCompanySearchEmpty: "Aucune fiche d'entreprise ou de litige trouvée pour \"{query}\".",
    globalCompanySearchError: "Erreur lors de la récupération des données de l'entreprise : {message}",
    dosarSearchStatus: "Recherche par numéro de dossier...",
    dosarSearchCount: "Recherche par numéro de dossier \"{numar}\" : {count} précédents judiciaires similaires identifiés.",
    dosarSearchEmpty: "Aucun précédent judiciaire similaire trouvé pour le dossier \"{numar}\"",
    copied: "Copié !",
    copyText: "Copier le Texte"
  }
};

export default mainContentTranslations;
